/**
 * We want to name these to describe the scenario rather than what page(s) they're used on.
 *
 * Naming convention: [PAST_TENSE_VERB]_[DESCRIPTOR_OF_STATE]
 * ex: Rather than "HAS_PART_QUESTIONS", we might name the
 *     scenario "CLICKED_FORWARD_WITH_PART_QUESTIONS"
 */

const navigationScenarios = {
    // General
    CLICKED_BACK: "CLICKED_BACK",
    CLICKED_FORWARD: "CLICKED_FORWARD",
    CLICKED_FORWARD_WITH_CASH: "CLICKED_FORWARD_WITH_CASH",
    CLICKED_FORWARD_WITH_INSURANCE: "CLICKED_FORWARD_WITH_INSURANCE",
    // CMS on the YMM estimate alert: {routerLink:service-zip, File an insurance claim}
    CLICKED_FILE_INSURANCE_CLAIM: "service-zip",
    CLICKED_CANCEL_VERIFICATION: "CLICKED_CANCEL_VERIFICATION",

    // Bailout
    BAILOUT: "BAILOUT",
    BAILOUT_SUCCESS: "BAILOUT_SUCCESS",
    CLICKED_BACK_TO_HOMEPAGE: "CLICKED_BACK_TO_HOMEPAGE",

    // TODO: use virtual page?
    // Vin selection
    CLICKED_BACK_WITH_VIN: "CLICKED_BACK_WITH_VIN",
    CLICKED_BACK_WITH_SKIP_VIN: "CLICKED_BACK_WITH_SKIP_VIN",
    CLICKED_FORWARD_WITH_VIN: "CLICKED_FORWARD_WITH_VIN",
    CLICKED_FORWARD_WITH_REPAIR_AND_VERIFIED_INSURANCE:
        "CLICKED_FORWARD_WITH_REPAIR_AND_VERIFIED_INSURANCE",
    CLICKED_FORWARD_WITH_REPLACE_AND_VERIFIED_INSURANCE:
        "CLICKED_FORWARD_WITH_REPLACE_AND_VERIFIED_INSURANCE",
    CLICKED_FORWARD_WITHOUT_VIN: "CLICKED_FORWARD_WITHOUT_VIN",
    CLICKED_FORWARD_WITH_SKIP_VIN: "CLICKED_FORWARD_WITH_SKIP_VIN",
    CLICKED_FORWARD_WITH_MULTIPLE_VEHICLES: "CLICKED_FORWARD_WITH_MULTIPLE_VEHICLES",
    SELECTED_VIN_WITH_MISMATCHED_GLASS: "SELECTED_VIN_WITH_MISMATCHED_GLASS",
    SELECTED_MANUAL_VIN: "SELECTED_MANUAL_VIN",
    SELECTED_LICENSE_PLATE: "SELECTED_LICENSE_PLATE",
    SELECTED_HOME_ADDRESS: "SELECTED_HOME_ADDRESS",
    SELECTED_NO_VIN: "SELECTED_NO_VIN",
    CLICKED_FORWARD_WITH_NO_QUESTIONS: "CLICKED_FORWARD_WITH_NO_QUESTIONS",
    CLICKED_VIN_RETRY: "CLICKED_VIN_RETRY",

    // Part selection
    CLICKED_FORWARD_WITH_PART_QUESTIONS: "CLICKED_FORWARD_WITH_PART_QUESTIONS",
    CLICKED_FORWARD_WITH_MULTIPLE_PARTS_TO_CHOOSE: "CLICKED_FORWARD_WITH_MULTIPLE_PARTS_TO_CHOOSE",
    CLICKED_FORWARD_WITH_MOLDING_QUESTIONS: "CLICKED_FORWARD_WITH_MOLDING_QUESTIONS",
    CLICKED_FORWARD_WITH_CAPABILITY_QUESTIONS: "CLICKED_FORWARD_WITH_CAPABILITY_QUESTIONS",
    CLICKED_FORWARD_WITH_NO_MORE_QUESTIONS: "CLICKED_FORWARD_WITH_NO_MORE_QUESTIONS",
    CLICKED_BACK_NON_CLAIM_AND_COVERAGE: "CLICKED_BACK_NON_CLAIM_AND_COVERAGE",
    CLICKED_BACK_RECALIBRATION_INFO: "CLICKED_BACK_RECALIBRATION_INFO",
    CLICKED_BACK_TO_COVERAGE_STATEMENT: "CLICKED_BACK_TO_COVERAGE_STATEMENT",
    CLICKED_BACK_TO_RECALIBRATION_INFO: "CLICKED_BACK_TO_RECALIBRATION_INFO",
    CLICKED_BACK_TO_POLICY_INFO_SUBMITTED: "CLICKED_BACK_TO_POLICY_INFO_SUBMITTED",
    CLICKED_BACK_WITH_PART_QUESTIONS: "CLICKED_BACK_WITH_PART_QUESTIONS",
    CLICKED_BACK_WITH_MULTIPLE_PARTS_TO_CHOOSE: "CLICKED_BACK_WITH_MULTIPLE_PARTS_TO_CHOOSE",
    CLICKED_BACK_WITH_MOLDING_QUESTIONS: "CLICKED_BACK_WITH_MOLDING_QUESTIONS",
    CLICKED_BACK_WITH_CAPABILITY_QUESTIONS: "CLICKED_BACK_WITH_CAPABILITY_QUESTIONS",
    CLICKED_BACK_WITH_VIN_AND_NO_MORE_QUESTIONS: "CLICKED_BACK_WITH_VIN_AND_NO_MORE_QUESTIONS",
    CLICKED_BACK_WITH_NO_VIN_NOR_QUESTIONS: "CLICKED_BACK_WITH_NO_VIN_NOR_QUESTIONS",

    // Insurance-Company
    CLICKED_PAY_ON_MY_OWN: "CLICKED_PAY_ON_MY_OWN",
    CLICKED_BACK_TO_ESTIMATE: "CLICKED_BACK_TO_ESTIMATE",
    CLICKED_FORWARD_POLICY_INFO: "CLICKED_FORWARD_POLICY_INFO",
    CLICKED_FORWARD_NON_CLAIM_AND_COVERAGE: "CLICKED_FORWARD_NON_CLAIM_AND_COVERAGE",
    CLICKED_FORWARD_WITH_ENDORSEMENTS: "CLICKED_FORWARD_WITH_ENDORSEMENTS",
    CLICKED_FORWARD_WITHOUT_ENDORSEMENTS: "CLICKED_FORWARD_WITHOUT_ENDORSEMENTS",
    CLICKED_FORWARD_WITH_DIFFERENT_VEHICLE: "CLICKED_FORWARD_WITH_DIFFERENT_VEHICLE",
    CLICKED_FORWARD_WITH_DIFFERENT_VEHICLE_WITHOUT_CAR_ID:
        "CLICKED_FORWARD_WITH_DIFFERENT_VEHICLE_WITHOUT_CAR_ID",
    CLICKED_FORWARD_WITHOUT_POLICY_VEHICLE: "CLICKED_FORWARD_WITHOUT_POLICY_VEHICLE",

    //Service-Location
    CLICKED_FORWARD_WITH_MOBILE_SERVICE: "CLICKED_FORWARD_WITH_MOBILE_SERVICE",

    //Customer-details
    CLICKED_BACK_WITH_MOBILE_SERVICE: "CLICKED_BACK_WITH_MOBILE_SERVICE",

    // Schedule
    CLICKED_CHANGE_LOCATION: "CLICKED_CHANGE_LOCATION",
    ZIP_CODE_CHANGED_RECAL_ACK: "ZIP_CODE_CHANGED_RECAL_ACK",

    // Payment
    CLICKED_INSURANCE: "CLICKED_INSURANCE",
    CLICKED_PAY_NOW: "CLICKED_PAY_NOW",
    CLICKED_PAY_NOW_ADYEN: "CLICKED_PAY_NOW_ADYEN",
    CLICKED_PAY_LATER: "CLICKED_PAY_LATER",
    CLICKED_SWITCH_TO_INSHOP: "CLICKED_SWITCH_TO_INSHOP",
    PIA_ERROR: "PIA_ERROR",
    PIA_CC_ERROR: "PIA_CC_ERROR",
    PIA_APPLE_ERROR: "PIA_APPLE_ERROR",
    PIA_AFTERPAY_ERROR: "PIA_AFTERPAY_ERROR",
    PIA_SUCCESS: "PIA_SUCCESS",

    // Return User
    CLICKED_RESTART: "CLICKED_RESTART",
};

export { navigationScenarios };
